// extracted by mini-css-extract-plugin
module.exports = {"smallhr":"ProductType_smallhr__3KrAU"};